module.exports = __webpack_public_path__ + "static/img/img_float_wxpub_qr.eb0ec25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_float_wxpub_qr.png
// module id = lL9A
// module chunks = 1